export enum ChatsStatusEnum {
    EM_ANDAMENTO = 1,
    FINALIZADO = 2,
}